import React         from 'react'; 
import Paper         from '../components/Paper.jsx';
import {Context}     from '../services/context.js';
import cx            from 'classnames';
import portrait      from './portrait.module.css';
import landscape     from './investors.module.css';

import pic_digging_1 from '../pictures/One digging for gold.webp';
import pic_digging_2 from '../pictures/Professional digging-1.webp';

import { Helmet }           from 'react-helmet';


//console.log('Context', Context.portrait)  

const cx_title  = cx({[portrait.title]:  Context.portrait, [landscape.title]:   !Context.portrait});
const cx_header = cx({[portrait.header]: Context.portrait, [landscape.header]:  !Context.portrait});
const cx_text   = cx({[portrait.text]:   Context.portrait, [landscape.text]:    !Context.portrait});
const cx_ul     = cx({[portrait.ul]:     Context.portrait, [landscape.ul]:      !Context.portrait});
const cx_li     = cx({[portrait.li]:     Context.portrait, [landscape.li]:      !Context.portrait});


  const text_1 = [ {header: <p className={cx_header}> Value through Innovation <br/>  Solving the Trust Problem!</p>},
    {text: <p>
     <ul className={cx_ul}>
        <li className={cx_li}>Trust is missing everywhere—politics, finance, business, relationships, and more.</li> 
        <li className={cx_li}>There are currently no real technical solutions to address this issue.</li> 
        <li className={cx_li}>Existing blockchains can’t solve the trust problem efficiently.</li>
        <li className={cx_li}>They are <strong>too slow</strong>, <strong>energy-hungry, expensive, and complex</strong> for most use cases.</li>
        <li className={cx_li}>A new approach is needed. Keep reading…</li>
      </ul>
    </p>}]

const text_2 = [
  {
    header: (
      <p className={cx_header}>
        The Solution<br />
        Back‑Step Blockchain
      </p>
    )
  },
  {
    text: (
      <p>
        <ul className={cx_ul}>
          <li className={cx_li}>
            The Back‑Step Blockchain revolutionizes the landscape, removing previous limitations on use cases and growth.
          </li>
          <li className={cx_li}>
            It rests on four fundamental pillars: speed, energy efficiency, connectivity, and cost.
          </li>
          <li className={cx_li}>
            Key facts: up to millions of blocks per second, less than 100 μW per block, and only three nodes required for redundancy.
          </li>
          <li className={cx_li}>
            These core attributes redefine the boundaries of blockchain applicability and set a new benchmark for expansion.
          </li>
          <li className={cx_li}>
            It is the first blockchain that can be integrated into mobile devices, office equipment, and data centers.
          </li>
          <li className={cx_li}>
            It is the first blockchain that can be integrated into processors.
          </li>
          <li className={cx_li}>
            New applications where blockchains interact with other blockchains enable trusted B2B, B2U, and U2U transactions.
          </li>
        </ul>
      </p>
    )
  }
];

const text_3 = [
  {
    header: (
      <p className={cx_header}>
        Proof of Concept – Yes, It’s Real!
      </p>
    )
  },
  {
    text: (
      <p>
        <ul className={cx_ul}>
          <li className={cx_li}>
            Trust.it is the first application built on the Back‑Step Blockchain—see more on this website.
          </li>
          <li className={cx_li}>
            Accessible to everyone at trust-it.app once our data center is fully operational.
          </li>
          <li className={cx_li}>
            Patented in key regions including China, the US, India, Europe, and more.
          </li>
          <li className={cx_li}>
            Read the white paper on AI integration on this website.
          </li>
        </ul>
      </p>
    )
  }
];

const text_31 = [
  {
    header: (
      <p className={cx_header}>
        The Integrated Solution!
      </p>
    )
  },
  {
    text: (
      <p>
        <ul className={cx_ul}>
          <li className={cx_li}>
            In 2010, it became clear that many applications require encryption—Intel integrated encryption support directly into its CPUs.
          </li>
          <li className={cx_li}>
            Recently, many companies have integrated AI functions into their processors, recognizing that AI will be essential for all.
          </li>
          <li className={cx_li}>
            Now is the time to plan <strong>trust</strong> functions for the next generation of processors and AI chips.
          </li>
          <li className={cx_li}>
            Innovative partners will integrate this into chips for mobile devices, office equipment, and data centers.
          </li>
        </ul>
      </p>
    )
  }
];

const text_4 = [
  {
    header: (
      <p className={cx_header}>
        Multiple Business Models<br />
        Path to Growth
      </p>
    )
  },
  {
    text: (
      <p>
        <ul className={cx_ul}>
          <li className={cx_li}>
            Trust.it for individual users and small companies—generating revenue per block.
          </li>
          <li className={cx_li}>
            Back‑Step Blockchain data centers offering virtual blockchains to customers under volume‑ or usage‑based contracts.
          </li>
          <li className={cx_li}>
            Selling Back‑Step Blockchain generator hardware to customers running their own chains—hardware revenue plus block usage fees.
          </li>
          <li className={cx_li}>
            Licensing Back‑Step Blockchain technology to companies with in‑house product development and foundry capabilities (e.g., Intel, Samsung, Huawei, etc.).
          </li>
          <li className={cx_li}>
            Licensing Back‑Step Blockchain technology to companies without in‑house fabrication (e.g., AMD, NVIDIA, Apple, Google, Microsoft, Qualcomm, Infineon, STMicroelectronics, ARM, etc.).
          </li>
        </ul>
      </p>
    )
  }
];

const text_5 = [
  {
    header: (
      <p className={cx_header}>
        Business Plan for Trust.it
      </p>
    )
  },
  {
    text: (
      <p>
        <ul className={cx_ul}>
          <li className={cx_li}>
            An initial business plan for Trust.it is available upon request.
          </li>
          <li className={cx_li}>
            The business plan is based on the following assumptions:
          </li>
          <li className={cx_li}>
            50,000 users in year one; 200,000 users in year two; and 1,000,000 users in year three.
          </li>
          <li className={cx_li}>
            Thirty-five percent of users will use Trust.it for business purposes.
          </li>
          <li className={cx_li}>
            Twenty-five percent of users will use Trust.it for personal purposes.
          </li>
          <li className={cx_li}>
            Forty percent of users will use Trust.it for reading only, with the potential to register in the future.
          </li>
          <li className={cx_li}>
            Plans for other business models are still in development.
          </li>
        </ul>
      </p>
    )
  }
];


const text_6 = [
  {
    header: (
      <p className={cx_header}>
        Yes, We Want Your Help!
      </p>
    )
  },
  {
    text: (
      <p>
        <ul className={cx_ul}>
          <li className={cx_li}>
            People say we excel at technology innovation and product design.
          </li>
          <li className={cx_li}>
            Marketing and business management are not our core disciplines.
          </li>
          <li className={cx_li}>
            We are looking for a partner to support our marketing and business management efforts.
          </li>
          <li className={cx_li}>
            A strategic partnership with an established company is welcome.
          </li>
          <li className={cx_li}>
            An investment of 5–10 million SGD will help jump-start international operations.
          </li>
        </ul>
      </p>
    )
  }
]


export class Investors extends React.Component  
{

  //------------------------------------------------------------------
  //  Constructor
  //------------------------------------------------------------------
  constructor(props)
  {
    super(props);
    this.component= "";
    this.state = {content_disabled: false}
  }

  //------------------------------------------------
  //  Component Mount
  //------------------------------------------------
  componentDidMount()
  {
    window.scrollTo({top:0, left: 0, behavious: 'smooth'});
  }



  //------------------------------------------------------------------
  //
  //------------------------------------------------------------------
  changeVisible(mode)
  {
    this.setState({content_disabled:mode})
  }

  //--------------------------------------------------------------------------
  // Rendering
  //--------------------------------------------------------------------------
  render()
  { 
    if (Context.portrait)
    {

      this.component = 
        <div className='portrait_backdrop'>

          <Helmet>
            <title>For Investors</title>
            <meta name="description" content="Why investing in Back-Step BlockcInformation for investors and partners"/>
            <meta charset="utf-8" />
          </Helmet> 

          <div className={cx_title }>
            Information for Investors and Partners
          </div>
          
          <div> 
          < Paper   textLines = {text_1}/> 
          </div>


          <div>
            <Paper  textLines = {text_2}/>
          </div>
        
          <div>
            <Paper  textLines = {text_3}/>
          </div>
        
          <div>
            <Paper textLines = {text_31}/>
          </div>

          <div>
            <Paper  textLines = {text_4}/>
          </div>
        
          <div>
            <Paper  textLines = {text_5}/>
          </div>

          <div>
            <Paper  textLines = {text_6}/>
          </div>

          <div  className={landscape.text}>
            <p>From here...</p>
            <img src={pic_digging_1} width='250' alt="digging for gold" />
          </div>
    
          <div  className={landscape.text}>
            <p>...to here.</p>
            <img src={pic_digging_2} width='250' alt="team digging for much more gold" />
          </div>
        </div>
    }
    else
    {
      this.component = 
      <div className={landscape.backdrop} onMouseDown={()=>this.changeVisible(true)} onMouseUp={()=>this.changeVisible(false)} onContextMenu={(e) => e.preventDefault()}>
          <Helmet>
            <title>Investors</title>
            <meta name="description" content="Why investing in Back-Step Blockchain is wise and makes the products grow fast. Pictures included." />
            <meta charset="utf-8" />
          </Helmet>

          {! this.state.content_disabled &&
          <>
    
          <div className={landscape.title_location}>
            <div className={landscape.title_text}> 
              <p>Information for Investors and Partners</p>
            </div>
          </div>

          <div className={landscape.container_2_5_2}>

            <div className ={landscape.grid_item}> 
            < Paper   textLines = {text_1}/> 
            </div>

            <div className ={landscape.grid_item}>
              <Paper  textLines = {text_2}/>
            </div>
          
            <div className ={landscape.grid_item}>
              <Paper  textLines = {text_3}/>
            </div>

            <div className ={landscape.grid_item}>
              <Paper textLines = {text_31}/>
            </div>
          
            <div className ={landscape.grid_item}>
              <Paper  textLines = {text_4}/>
            </div>
          
            <div className ={landscape.grid_item}>
              <Paper  textLines = {text_5}/>
            </div>

            <div className ={landscape.grid_item}>
              <Paper  textLines = {text_6}/>
            </div>
      
          </div>
          </>
          }
        </div>
    }
      return this.component;
  }

}